import { Card, CardContent, Typography, CardHeader, Avatar, Divider } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useFormContext } from 'react-hook-form';

interface SummaryList {
  label: string;
  fieldName: string;
}

interface SendingOrderFormSummaryProps {
  formSummaryList: Array<SummaryList> | undefined;
}

// TODO: Översätt
export const SendingOrderFormSummary = ({ formSummaryList }: SendingOrderFormSummaryProps) => {
  const { watch } = useFormContext();

  return (
    <Card
      variant='outlined'
      sx={{
        m: 1,
        borderWidth: 2,
      }}
    >
      <CardHeader
        avatar={
          <Avatar variant='rounded'>
            <AssignmentIcon />
          </Avatar>
        }
        title={<Typography variant='h5'>Summering</Typography>}
      />
      <Divider variant='middle' />
      <CardContent>
        {formSummaryList &&
          formSummaryList.map((item) => {
            if (watch(item.fieldName)) {
              return (
                <div key={item.fieldName}>
                  <Typography color='textSecondary' variant='body2'>
                    {item.label}
                  </Typography>
                  <Typography variant='h6' gutterBottom sx={{ lineHeight: 1.2 }}>
                    {watch(item.fieldName).label ? watch(item.fieldName).label : watch(item.fieldName)}
                  </Typography>
                </div>
              );
            }
            return null;
          })}
      </CardContent>
    </Card>
  );
};
